import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "92%",
  maxWidth: 420,
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "#FFFFFF",
  borderRadius: "20px",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
  outline: "none",
  p: "24px",
};

export default function ChooseCardModal({
  open,
  handleClose,
  cards = [],
  selectedCard,
  onSelectCard,
  onOpenAddCard,
}) {
  const handleCardClick = (card) => {
    if (onSelectCard) {
      onSelectCard(card);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 300,
        sx: { backgroundColor: "rgba(0, 0, 0, 0.55)" },
      }}
    >
      <Fade in={open}>
        <Box sx={modalStyle}>
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-[18px] font-[700] text-[#1E222B]">
              Your Cards
            </h2>
            <div
              onClick={handleClose}
              className="w-8 h-8 rounded-full bg-[#18191B] hover:bg-black text-white flex items-center justify-center cursor-pointer transition shadow-xs"
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </div>
          </div>

          <p className="text-[13px] text-[#6B7280] mb-5">
            Select a card to use for your savings plan or add a new one.
          </p>

          {/* Cards List */}
          <div className="space-y-3 mb-5">
            {cards && cards.length > 0 ? (
              cards.map((card) => {
                const isSelected =
                  selectedCard &&
                  (selectedCard.id === card.id ||
                    selectedCard.last4 === card.last4);

                return (
                  <div
                    key={card.id || card.last4}
                    onClick={() => handleCardClick(card)}
                    className={`rounded-2xl p-4 border transition cursor-pointer flex items-center justify-between ${
                      isSelected
                        ? "border-[#00BC67] bg-[#F5FCF8] ring-1 ring-[#00BC67]/30 shadow-2xs"
                        : "border-gray-200/80 bg-white hover:border-gray-300 hover:bg-gray-50/50"
                    }`}
                  >
                    <div className="flex items-center gap-3.5">
                      {/* Card Brand Badge */}
                      <div className="w-11 h-11 rounded-xl bg-[#F0F2F5] flex items-center justify-center shrink-0">
                        {card.brand === "visa" ? (
                          <span className="text-[11px] font-black italic tracking-tighter text-[#1A1F71] bg-white px-1.5 py-0.5 rounded shadow-2xs border border-gray-100">
                            VISA
                          </span>
                        ) : (
                          <div className="flex items-center -space-x-1.5">
                            <div className="w-4 h-4 rounded-full bg-[#EB001B]" />
                            <div className="w-4 h-4 rounded-full bg-[#F79E1B] opacity-90" />
                          </div>
                        )}
                      </div>

                      <div>
                        <div className="flex items-center gap-2">
                          <span className="font-[700] text-[15px] text-[#1E222B]">
                            •••• {card.last4}
                          </span>
                          {card.isDefault && (
                            <span className="text-[10px] font-[600] px-2 py-0.5 rounded-full bg-[#E6F8F0] text-[#00BC67]">
                              Default
                            </span>
                          )}
                        </div>
                        <p className="text-[12px] text-gray-500 mt-0.5">
                          Expires {card.expiry}
                          {card.bankName ? ` • ${card.bankName}` : ""}
                        </p>
                      </div>
                    </div>

                    {/* Radio Indicator */}
                    <div className="shrink-0 pl-2">
                      {isSelected ? (
                        <div className="w-5 h-5 rounded-full border-2 border-[#00BC67] flex items-center justify-center">
                          <div className="w-2.5 h-2.5 rounded-full bg-[#00BC67]" />
                        </div>
                      ) : (
                        <div className="w-5 h-5 rounded-full border-2 border-gray-300" />
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="text-center py-6 text-gray-400 text-[14px]">
                No cards saved yet
              </div>
            )}
          </div>

          {/* Add New Card Button */}
          <div className="mb-6">
            <button
              type="button"
              onClick={onOpenAddCard}
              className="w-full py-3 px-4 rounded-xl border border-dashed border-[#00BC67] bg-[#F5FCF8] hover:bg-[#E6F8F0] text-[#00BC67] font-[600] text-[14px] flex items-center justify-center gap-2 cursor-pointer transition"
            >
              <AddIcon sx={{ fontSize: 18 }} />
              <span>Add New Card</span>
            </button>
          </div>

          {/* Confirm Selection CTA */}
          <button
            type="button"
            onClick={handleClose}
            className="w-full py-3.5 rounded-xl bg-[#00BC67] hover:bg-[#00a85c] text-white font-[700] text-[15px] cursor-pointer transition shadow-xs text-center"
          >
            Select Card
          </button>
        </Box>
      </Fade>
    </Modal>
  );
}
